import { render } from "./HolidaysList.vue?vue&type=template&id=6fbf3321&scoped=true"
import script from "./HolidaysList.vue?vue&type=script&lang=js"
export * from "./HolidaysList.vue?vue&type=script&lang=js"

import "./HolidaysList.vue?vue&type=style&index=0&id=6fbf3321&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbf3321"]])

export default __exports__